import { type HTMLContentType } from '@/common/types/dedicated-personal-page.type';
import { useQuery } from '@tanstack/react-query';

import Client from '@/common/utils/client.utility';

export const getAboutUs = async () => {
  const client = new Client();
  return await client.get<HTMLContentType>('/v1/personalpage/Shopper/AboutUs');
};

export const useGetAboutUs = () =>
  useQuery({
    queryFn: getAboutUs,
    queryKey: ['about_us'],
  });
